import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";
import { commonTableStyles as styles } from "./styles";

export type TableFilterOption = {
  id: string;
  label: string;
};

type TableFilterSelectProps = {
  label: string;
  value: string;
  options: TableFilterOption[];
  onChange: (event: SelectChangeEvent) => void;
  fieldSx?: SxProps<Theme>;
};

/**
 * Outlined select styled to match table filter autocompletes.
 */
const TableFilterSelect = ({
  label,
  value,
  options,
  onChange,
  fieldSx,
}: TableFilterSelectProps) => {
  const labelId = `table-filter-${label.replace(/\s+/g, "-").toLowerCase()}`;

  const menu = options.map((item) => (
    <MenuItem key={`${labelId}-${item.id}`} value={item.id}>
      {item.label}
    </MenuItem>
  ));

  if (fieldSx) {
    return (
      <Box sx={fieldSx}>
        <Box component="span" sx={{ display: "block", mb: "6px", fontSize: 12, fontWeight: 600, lineHeight: "16px", color: "#5C5870" }}>
          {label}
        </Box>
        <Select fullWidth size="small" value={value} onChange={onChange} variant="outlined">
          {menu}
        </Select>
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small" sx={styles.filterFieldRoot}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={onChange}
        variant="outlined"
      >
        {menu}
      </Select>
    </FormControl>
  );
};

export default TableFilterSelect;
